const HATS      = ['🎩', '👒', '👑', '🎓', '🪖', '🧢', '⛑️', null, null, null];
const GLASSES   = ['🕶️', '👓', null, null, null];
const EXTRAS    = ['💎', '🎀', '🧔', '💍', '🏴‍☠️', '🤙', '🪬', null, null];
const BG_COLORS = ['#f9a825','#e53935','#1e88e5','#43a047','#8e24aa','#00acc1','#ff7043','#546e7a','#d81b60','#00897b'];

function seeded(n, offset = 0) {
  const x = Math.sin(n * 9301 + offset * 49297 + 233) * 1000003;
  return x - Math.floor(x);
}

function pick(arr, seed, offset) {
  return arr[Math.floor(seeded(seed, offset) * arr.length)];
}

export default function CowAvatar({ seed, size = 40 }) {
  const s      = Number(seed) || 1;
  const bg     = pick(BG_COLORS, s, 0);
  const hat    = pick(HATS,      s, 1);
  const glass  = pick(GLASSES,   s, 2);
  const extra  = pick(EXTRAS,    s, 3);

  const cowSize     = size * 0.58;
  const accessory   = size * 0.34;
  const hatSize     = size * 0.40;

  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: bg, position: 'relative',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexShrink: 0, overflow: 'visible',
    }}>
      {hat && (
        <span style={{
          position: 'absolute', top: -size * 0.30,
          fontSize: hatSize, lineHeight: 1, zIndex: 2,
          userSelect: 'none',
        }}>{hat}</span>
      )}

      {/* Cara de vaca */}
      <span style={{ fontSize: cowSize, lineHeight: 1, zIndex: 1, userSelect: 'none' }}>🐮</span>

      {glass && (
        <span style={{
          position: 'absolute', bottom: size * 0.12, right: -size * 0.08,
          fontSize: accessory, lineHeight: 1, zIndex: 3, userSelect: 'none',
        }}>{glass}</span>
      )}

      {extra && (
        <span style={{
          position: 'absolute', bottom: size * 0.02, left: -size * 0.08,
          fontSize: accessory, lineHeight: 1, zIndex: 3, userSelect: 'none',
        }}>{extra}</span>
      )}
    </div>
  );
}
